export const moneyFormatter = (value: string | number | undefined) =>
  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const moneyParser = (value: string | undefined) =>
  (value && parseInt(value.replace(/\$\s?|(,*)/g, ''), 10)) || 0;

export const percentageFormatter = (value?: number) => `${value}%`;
